import type { AppFeatureDefinition } from "@nasam/kernel";
import { createWorkforceRoutes } from "./presentation/routes";

// Irregular: workforce only ever grants view.
const PROFILE_SUMMARY_VIEW = "workforce.workforce_management.profile_summary.view";

export const workforceFeature: AppFeatureDefinition = {
  id: "workforce",
  version: "0.1.0",
  titleKey: "common:businessModules.workforce",
  icon: "UserCheck",
  basePath: "/workforce",
  requiredPermissions: [PROFILE_SUMMARY_VIEW],
  navigation: [
    {
      id: "workforce",
      titleKey: "common:businessModules.workforce",
      icon: "UserCheck",
      placement: "rail",
      order: 40,
      children: [
        {
          id: "workforce-profile-summary",
          titleKey: "workforce:nav.profileSummary",
          placement: "drawer",
          order: 10,
          path: "/workforce/profile-summary",
          requiredPermissions: [PROFILE_SUMMARY_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createWorkforceRoutes({ context }),
  i18n: {
    namespace: "workforce",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "workforce",
      labelKey: "workforce:permissions.workforce",
      children: [
        {
          segment: "workforce_management",
          labelKey: "workforce:permissions.workforceManagement",
          children: [
            {
              segment: "profile_summary",
              labelKey: "workforce:permissions.profileSummary",
              actions: [{ id: "view", labelKey: "workforce:actions.view" }],
            },
          ],
        },
      ],
    },
  ],
};
